export const scannerSeparatorsCharacters = ["@", '"', '™'];

export const isSeparatorCharacters = (value: string): boolean => {
  let result: boolean = false;
  scannerSeparatorsCharacters.forEach((element) => {
    if (value.includes(element)) {
      result = true;
    }
  });
  return result;
};

export const getSeparator = (result: string): string => {
  let separator: string = "";
  scannerSeparatorsCharacters.forEach((element) => {
    if (result.includes(element)) {
      separator = element;
    }
  });
  return separator;
};
